import { connect } from 'react-redux';
import { Preview } from './component';
const mapStateToProps = (state) => ({
    size: state.page.size,
    orientation: state.page.orientation,
    margins: state.page.margins,
    pageTemplates: state.page.pageTemplates,
});
export const PreviewContainer = connect(mapStateToProps, null, null, { forwardRef: true })(Preview);
//# sourceMappingURL=container.js.map